(function() {
  if (window.TabbedFeaturedCollectionDynamicSources) return;

  var OBSERVER_ROOT_MARGIN = '300px 0px';
  var states = new WeakMap();
  var requestCounter = 0;
  var allowedLazyScriptSrcs = new Set();

  function toPositiveInteger(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function getRecentlyViewedProductIds(rawValue, excludedProductId, limit) {
    var stored;

    try {
      stored = JSON.parse(rawValue || '[]');
    } catch (error) {
      return [];
    }

    if (!Array.isArray(stored)) return [];

    var excludedId = parseProductId(excludedProductId);
    var max = toPositiveInteger(limit, 12);
    var seen = new Set();
    var ids = [];

    stored.forEach(function(value) {
      var id = parseProductId(value);
      if (!id) return;
      if (excludedId && id === excludedId) return;
      if (seen.has(id)) return;
      seen.add(id);
      ids.push(id);
    });

    return ids.slice(0, max);
  }

  function parseProductId(value) {
    if (Number.isInteger(value) && value > 0) return value;
    if (typeof value !== 'string') return null;
    var trimmed = value.trim();
    if (!/^\d+$/.test(trimmed)) return null;
    var id = Number(trimmed);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
  }

  function buildRecentlyViewedSearchUrl(baseUrl, productIds) {
    var query = productIds.map(function(id) {
      return 'id:' + id;
    }).join(' OR ');

    if (!query) return null;

    return baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(query).replace(/%20/g, '+');
  }

  function getRecentlyViewedIdsFromStorage(panel) {
    try {
      return getRecentlyViewedProductIds(
        window.localStorage && window.localStorage.getItem('theme-recently-viewed'),
        panel.dataset.productId,
        panel.dataset.productLimit
      );
    } catch (error) {
      return [];
    }
  }

  function removeExecutableNodes(root) {
    root.querySelectorAll('script, link[rel="stylesheet"], style, lazy-script').forEach(function(node) {
      node.remove();
    });
  }

  function extractResultMarkup(html, sourceId) {
    if (!sourceId) return null;

    var template = document.createElement('template');
    template.innerHTML = html;
    var escapedSourceId = window.CSS && window.CSS.escape ? window.CSS.escape(sourceId) : sourceId.replace(/"/g, '\\"');
    var source = template.content.querySelector('[data-tfc-source-id="' + escapedSourceId + '"]');
    if (!source) return null;

    var result = source.querySelector('[data-tfc-dynamic-result]');
    if (!result || result.childElementCount === 0) return null;

    removeExecutableNodes(result);
    return result.innerHTML.trim() ? result : null;
  }

  function sortRecentlyViewedItems(result, productIds) {
    var grid = result.querySelector('ul.product-grid');
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll('li[data-product-id]'));
    var sortedItems = productIds.map(function(id) {
      return items.find(function(item) {
        return parseInt(item.getAttribute('data-product-id'), 10) === id;
      });
    }).filter(Boolean);

    if (!sortedItems.length) return;
    grid.innerHTML = '';
    sortedItems.forEach(function(item) {
      grid.appendChild(item);
    });
  }

  function loadMatchingLazyScripts(root) {
    if (!root || !document.querySelectorAll) return;

    document.querySelectorAll('lazy-script[data-watch-element]').forEach(function(script) {
      var selectorList = (script.getAttribute('data-watch-element') || '').split(',').map(function(selector) {
        return selector.trim();
      }).filter(Boolean);

      var hasMatch = selectorList.some(function(selector) {
        try {
          return !!root.querySelector(selector);
        } catch (error) {
          return false;
        }
      });

      var src = script.getAttribute('src');

      if (hasMatch && src && allowedLazyScriptSrcs.has(src) && script.loadScript) script.loadScript();
    });
  }

  function setAllowedLazyScriptSrcs(srcs) {
    allowedLazyScriptSrcs = new Set((srcs || []).filter(Boolean));
  }

  function setAllowedLazyScriptSrcsFromOwner(owner) {
    if (!owner || !owner.dataset || !owner.dataset.dynamicScriptSrcs) return;
    setAllowedLazyScriptSrcs(owner.dataset.dynamicScriptSrcs.split(',').map(function(src) {
      return src.trim();
    }));
  }

  function refreshInjectedSlider(panel, component) {
    if (component && component._updateArrowSteps) component._updateArrowSteps();
    loadMatchingLazyScripts(panel);
    window.renderSelects?.();
    window.loadDesktopOnlyTemplates?.();
    window.stickersReinit?.();
  }

  function getFetchUrl(panel) {
    if (panel.dataset.sourceType === 'related') {
      return panel.dataset.productId && panel.dataset.recommendationsUrl ? panel.dataset.recommendationsUrl : null;
    }

    if (panel.dataset.sourceType === 'recently_viewed') {
      var productIds = getRecentlyViewedIdsFromStorage(panel);
      if (!productIds.length || !panel.dataset.searchUrl) return null;
      panel._tfcRecentlyViewedIds = productIds;
      return buildRecentlyViewedSearchUrl(panel.dataset.searchUrl, productIds);
    }

    return null;
  }

  function setPanelState(panel, state, owner) {
    panel.dataset.sourceState = state;
    if (state === 'loading') {
      panel.setAttribute?.('aria-busy', 'true');
    } else {
      panel.removeAttribute?.('aria-busy');
    }

    if (state === 'empty' || state === 'failed' || state === 'loaded') {
      panel.dataset.tfcHasProducts = state === 'loaded' ? 'true' : 'false';
      var component = owner || (panel.closest && panel.closest('tabbed-featured-collection'));
      if (component && typeof component._updateSectionVisibility === 'function') component._updateSectionVisibility();
    }
  }

  async function fetchAndInject(panel, component) {
    if (panel.dataset.sourceState !== 'idle') return;

    var url = getFetchUrl(panel);
    if (!url) {
      setPanelState(panel, 'empty', component);
      return;
    }

    var state = states.get(panel) || {};
    var requestId = ++requestCounter;
    var controller = new AbortController();
    state.controller = controller;
    state.requestId = requestId;
    states.set(panel, state);
    setPanelState(panel, 'loading');

    try {
      var response = await fetch(url, { signal: controller.signal });
      if (states.get(panel)?.requestId !== requestId) return;
      if (!response.ok) throw new Error(response.status);
      var result = extractResultMarkup(await response.text(), panel.dataset.tfcSourceId);
      if (states.get(panel)?.requestId !== requestId) return;

      if (!result) {
        setPanelState(panel, 'empty', component);
        return;
      }

      if (panel.dataset.sourceType === 'recently_viewed') {
        sortRecentlyViewedItems(result, panel._tfcRecentlyViewedIds || []);
      }

      var target = panel.querySelector('[data-tfc-dynamic-result]');
      if (!target) return;
      target.replaceChildren.apply(target, Array.from(result.childNodes));
      setPanelState(panel, target.childElementCount ? 'loaded' : 'empty', component);
      refreshInjectedSlider(panel, component);
    } catch (error) {
      if (states.get(panel)?.requestId !== requestId) return;
      setPanelState(panel, error.name === 'AbortError' ? 'idle' : 'failed', component);
    } finally {
      if (states.get(panel)?.requestId === requestId) states.delete(panel);
    }
  }

  function cleanupPanel(panel) {
    var state = states.get(panel);
    if (!state) return;
    if (state.observer) state.observer.disconnect();
    if (state.controller) state.controller.abort();
    if (panel.dataset.sourceState === 'loading') setPanelState(panel, 'idle');
    states.delete(panel);
  }

  function loadTabbedFeaturedCollectionSource(panel, component) {
    if (!panel || panel.dataset.sourceState !== 'idle') return;

    cleanupPanel(panel);

    var state = {};
    states.set(panel, state);

    var owner = component || panel.closest('tabbed-featured-collection');
    setAllowedLazyScriptSrcsFromOwner(owner);
    if (owner && !owner._tfcDynamicCleanupAttached) {
      owner._tfcDynamicCleanupAttached = true;
      owner.addEventListener('tabbed-featured-collection:disconnect', function() {
        owner.querySelectorAll('.tfc__panel').forEach(cleanupPanel);
      });
    }

    if (!('IntersectionObserver' in window)) {
      fetchAndInject(panel, owner);
      return;
    }

    state.observer = new IntersectionObserver(function(entries) {
      if (panel.hidden || !entries[0].isIntersecting) return;
      state.observer.disconnect();
      delete state.observer;
      fetchAndInject(panel, owner);
    }, { rootMargin: OBSERVER_ROOT_MARGIN });

    state.observer.observe(panel);
  }

  window.TabbedFeaturedCollectionDynamicSources = {
    getRecentlyViewedProductIds: getRecentlyViewedProductIds,
    buildRecentlyViewedSearchUrl: buildRecentlyViewedSearchUrl,
    extractResultMarkup: extractResultMarkup,
    getFetchUrl: getFetchUrl,
    loadMatchingLazyScripts: loadMatchingLazyScripts,
    setAllowedLazyScriptSrcs: setAllowedLazyScriptSrcs,
    cleanupPanel: cleanupPanel,
    getPanelState: function(panel) { return states.get(panel); },
    loadTabbedFeaturedCollectionSource: loadTabbedFeaturedCollectionSource
  };

  window.loadTabbedFeaturedCollectionSource = loadTabbedFeaturedCollectionSource;

  document.querySelectorAll('tabbed-featured-collection .tfc__panel[data-source-state="idle"]').forEach(function(panel) {
    if (!panel.hidden) loadTabbedFeaturedCollectionSource(panel, panel.closest('tabbed-featured-collection'));
  });
})();
